import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { axiosInstance, TAX_GROUP, TaxGroup } from '@/core';

export const useTaxGroups = () => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${TAX_GROUP}`;

  return useQuery<TaxGroup[]>({
    queryKey: ['taxGroups'],
    queryFn: () => axiosInstance.get(fullUrl).then((res) => res.data),
  });
};
